import React, { useContext } from 'react'
import { Grid, GridCell, Spacer, Text, View } from 'oio-react'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'
import { useGlobalState } from 'src/sites/state'

const InitiativeMetadataBlock = () => {
   const { theme } = useGlobalState()
   const { initiative } = useContext(InitiativeHierarchyContext)

   return (
      <Grid columns="1" spacing="20px">
         {initiative.numViews > 0 && (
            <GridCell>
               <View
                  width="100%"
                  borderBottom={`1px solid ${theme.tmpContentLineColor}`}
                  paddingBottom="20px">
                  <Text
                     size="0.7"
                     weight="medium"
                     transform="uppercase"
                     color="#aaa">
                     Views
                  </Text>
                  <Spacer size="1" />
                  <Text size="6" letterSpacing="-0.2px" color="#555">
                     {initiative.numViews}
                  </Text>
               </View>
            </GridCell>
         )}
         {initiative.thread.numEntries > 0 && (
            <GridCell>
               <View
                  width="100%"
                  borderBottom={`1px solid ${theme.tmpContentLineColor}`}
                  paddingBottom="20px">
                  <Text
                     size="0.7"
                     weight="medium"
                     transform="uppercase"
                     color="#aaa">
                     Replies
                  </Text>
                  <Spacer size="1" />
                  <Text size="6" letterSpacing="-0.2px" color="#555">
                     {initiative.thread.numEntries}
                  </Text>
               </View>
            </GridCell>
         )}
         <GridCell>
            <Text
               size="0.7"
               weight="medium"
               transform="uppercase"
               color="#aaa">
               Last Updated
            </Text>
            <Spacer size="1" />
            <Text size="1.5" letterSpacing="-0.1px" color="#444" weight="medium">
               {initiative.dateLastUpdated}
            </Text>
         </GridCell>
      </Grid>
   )
}

export default InitiativeMetadataBlock
